import { jwtDecode } from 'jwt-decode';

import { getMsalIdToken } from 'Services/MsalTokenService';
import { GET_USER_SUCCESS } from 'Constants/UserConstants';
import F2WCustomLogger from 'Services/F2WCustomLogger';

export function getUser() {
  function getUserSuccess(user) {
    return {
      type: GET_USER_SUCCESS,
      data: { user },
    };
  }

  return async function (dispatch) {
    try {
      const token = await getMsalIdToken();
      const profile = jwtDecode(token);
      const email = profile.email || profile.upn || profile.preferred_username;
      dispatch(
        getUserSuccess({
          ...profile,
          email: email?.toLowerCase(),
        })
      );
    } catch (error) {
      F2WCustomLogger.error('Failed to get user', error, { action: 'getUser' });
      dispatch(getUserSuccess(null));
    }
  };
}
